import React from "react";
import { useState, useEffect } from "react";
// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import Extensions from "./Extensions";
import CTA from "./CTA";
import { CSSTransition } from "react-transition-group";
import Gallery from "./Gallery";
import _ from "lodash";

const styled = {
  body: css`
    text-align: left;
  `,
  bodyWrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    //height: 470px;

    .place--body-text {
      align-self: flex-start;
    }
  `,
};

export default function PlaceTeaser(props) {
  const layoutStyles = css`
    //height: 500px;
    padding: 26px;
    box-shadow: ${props.activeStyle.border};
    //box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);
    opacity: ${props.activeStyle.opacity};
    border-radius: 15px;
    margin: 5px 0 10px 0;
    background-color: #f8f7f6;
    will-change: filter;

    h2 {
      text-align: left;
      font-family: "Readex Pro";
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 120%;
      margin-top: 0;

      /* or 29px */
      letter-spacing: -0.03em;
    }
  `;

  return (
    <div css={layoutStyles} className="place-teaser" id={props.place.nid}>
      <h2>{props.place.title}</h2>
      <div css={styled.bodyWrapper}>
        <div
          className="place--body-text"
          css={styled.body}
          dangerouslySetInnerHTML={{
            __html: props.place.description,
          }}
        />
        {!_.isEmpty(props.gallery) && <Gallery images={props.gallery} />}
        {props.extension && <Extensions extension={props.extension} />}
        {props.CTA && (
          <CSSTransition in={props.inProp} timeout={200} classNames="my-node">
            <CTA nid={props.place.nid} CTA={props.CTA} />
          </CSSTransition>
        )}
      </div>
    </div>
  );
}
